import { api } from "./client";

// La isla de la Explanada: el buzón de ideas y quien lo atiende.
//
// `manda` devuelve la sugerencia YA GUARDADA con la respuesta de Alpha dentro, en ese
// orden: el backend escribe primero y contesta después, así que un fallo de IA deja una
// idea sin frase y nunca una idea perdida (R11.1).
export const mandaSugerencia = async (texto) =>
  (await api.post("/sugerencias", { texto })).data;

export const getMisSugerencias = async () => (await api.get("/sugerencias")).data;

// LOS REPORTES (W22): «creo que mi respuesta está bien». El camino, en `sugerencias/reportes.py`.
export const mandaReporte = async (reporte) => (await api.post("/sugerencias/reportes", reporte)).data;

export const getAvisosDeReportes = async () => (await api.get("/sugerencias/reportes/avisos")).data;

export const getPanelDeReportes = async () => (await api.get("/sugerencias/reportes/panel")).data;

export const decideReporte = async (lesson_id, pregunta, decision) =>
  (await api.post("/sugerencias/reportes/decide", { lesson_id, pregunta, decision })).data;
